<template>
  <div class="album-card-wrapper" @click="handleCardClick">
    <el-card :body-style="{ padding: '0px' }" class="album-card" shadow="hover">
      <div class="image-container">
        <el-image
          lazy
          fit="cover"
          :src="imageAlbum.coverUrl"
          class="album-cover"
        >
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline" />
          </div>
        </el-image>

        <div class="count-badge">
          <i class="el-icon-picture-outline" />
          <span>{{ imageAlbum.total }}</span>
        </div>
      </div>

      <div class="album-info">
        <div class="album-title">{{ imageAlbum.albumName }}</div>
        <div v-if="imageAlbum.username" class="album-meta">
          <span class="author">@{{ imageAlbum.username }}</span>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'ImageAlbumCard',
  props: {
    imageAlbum: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleCardClick() {
      this.$router.push(`/image/${this.imageAlbum.albumId}`)
    }
  }
}
</script>

<style scoped>
.album-card-wrapper {
  cursor: pointer;
  margin-bottom: 15px;
}
.album-card {
  border: none !important;
  border-radius: 8px !important;
  overflow: hidden;
}
.image-container {
  position: relative;
  width: 100%;
  padding-top: 125%; /* 4:5 比例 */
  background: #f5f7fa;
}
.album-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.count-badge {
  position: absolute;
  bottom: 8px;
  right: 8px;
  padding: 2px 8px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  color: #fff;
  font-size: 11px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.album-info {
  padding: 10px;
}
.album-title {
  font-size: 14px;
  font-weight: 500;
  color: #18191c;
  line-height: 1.4;
  height: 40px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.album-meta {
  margin-top: 5px;
  font-size: 12px;
  color: #9499a0;
}
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #e3e5e7;
}
</style>
